import {
  useController,
  Control,
  FieldValues,
  FieldPath,
  RegisterOptions,
} from "react-hook-form";
import InputField, { InputFieldProps } from "./InputField";

interface ControlledInputFieldProps<TFieldValues extends FieldValues>
  extends Omit<
    InputFieldProps,
    "name" | "inputRef" | "onChange" | "onBlur" | "value" | "error"
  > {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>; // react-hook-form control object
  rules?: Omit<
    RegisterOptions<TFieldValues, FieldPath<TFieldValues>>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
}

export default function ControlledInputField<TFieldValues extends FieldValues>(
  props: ControlledInputFieldProps<TFieldValues>,
) {
  const { name, control, rules, ...otherProps } = props;

  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  return (
    <InputField
      {...otherProps}
      onChange={field.onChange} // send value to hook form
      onBlur={field.onBlur} // notify when input is touched/blur
      value={field.value} // input value
      name={field.name} // send down the input name
      inputRef={field.ref} // send input ref, so we can focus on input when error appears
      error={fieldState.error?.message}
    />
  );
}
